import React from 'react'
import type { BuildButtonProviderProps } from './Context'
import { BuildButtonProvider } from './Context'
import { Layout } from './Layout'

export const BuildButton = (props: Omit<BuildButtonProviderProps, 'children'>) => {
  //show only if the product type is Inventory or Non-Inventory
  return (
    <BuildButtonProvider {...props}>
      <Layout />
    </BuildButtonProvider>
  )
}
